<section class="news-detail-page">
  <p class="state" *ngIf="isLoading">Loading story...</p>
  <p class="state error" *ngIf="!isLoading && errorMessage">{{ errorMessage }}</p>

  <ng-container *ngIf="!isLoading && !errorMessage && article">
    <div class="news-detail-hero" [style.background-image]="'url(' + article.imageUrl + ')'">
      <div class="hero-overlay"></div>
      <div class="hero-content">
        <a routerLink="/news-promotions" class="back-link">Back to News & Promotions</a>
        <span class="badge">{{ article.type }}</span>
        <h1>{{ article.title }}</h1>
        <p class="meta">{{ article.publishedDate | date:'MMMM d, y' }}</p>
        <p>{{ article.summary }}</p>
      </div>
    </div>

    <div class="news-detail-content">
      <article class="content-card">
        <p *ngFor="let paragraph of contentParagraphs">{{ paragraph }}</p>
        <p *ngIf="contentParagraphs.length === 0">Full story content is not available yet.</p>
      </article>
    </div>
  </ng-container>
</section>
